export type Asset = {
  url?: string;
  description?: string;
  width?: number;
  height?: number;
};

export enum AssetPosition {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
}

export enum DisplayOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
